export const CONTACT_TYPES = ["Compras", "Ventas", "Retenciones", "Operaciones"]